// extracted by mini-css-extract-plugin
export default {"content":"CreateCalendarEvent_content__OUtBj","submitButton":"CreateCalendarEvent_submitButton__nyrXS","warningOverwrite":"CreateCalendarEvent_warningOverwrite__ZJiY3"};